/** Defaults for users/{uid}.notifications.games. Settings UI is a later prompt. */
export const DEFAULT_NOTIFICATION_GAMES = {
  enabled: true,
  played: true,
  passed: false,
  weekly: true,
  box: true,
};

export function resolveNotificationGames(existing) {
  const games = existing && typeof existing === "object" ? existing : {};
  return {
    enabled: games.enabled ?? DEFAULT_NOTIFICATION_GAMES.enabled,
    played: games.played ?? DEFAULT_NOTIFICATION_GAMES.played,
    passed: games.passed ?? DEFAULT_NOTIFICATION_GAMES.passed,
    weekly: games.weekly ?? DEFAULT_NOTIFICATION_GAMES.weekly,
    box: games.box ?? DEFAULT_NOTIFICATION_GAMES.box,
  };
}
